import { CLEAR_ALL_RETURNS } from '../constants/ActionTypes'

export default function clearAllReturns() {
    return {
        type: CLEAR_ALL_RETURNS
    }
}
